module.exports = __webpack_public_path__ + "static/img/stl_qr_back_2x.fd23761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stl_qr_back_2x.png
// module id = 2gD5
// module chunks = 1